import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './ContactUs.css';
import background from './ContactUS.jfif';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const isNameValid = (name) => {
    // Check if the name contains any numbers
    return !/\d/.test(name);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validate the name field
    if (name === 'name' && !isNameValid(value)) {
      alert('Name should not contain numbers');
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    // Check if all fields are filled out
    setIsButtonDisabled(
      !(formData.name && formData.email && formData.message)
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_gk8811e', // Replace with your EmailJS service ID
        'template_c6easzj', // Replace with your EmailJS template ID
        e.target,
        '0SDMQRih-GE6nlygP' // Replace with your EmailJS user ID
      )
      .then(
        (result) => {
          alert('Message Sent!');
          setFormData({ name: '', email: '', message: '' });
          setIsButtonDisabled(true); // Reset button to disabled
        },
        (error) => {
          console.log(error.text);
          alert('Failed to send message, please try again later.');
        }
      );
  };

  return (
    <div className="contact-us" style={{ backgroundImage: `url(${background})` }}>
      <h2>Contact Us</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            name="email"
            id="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            name="message"
            id="message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <button type="submit" disabled={isButtonDisabled}>
          Send
        </button>
      </form>
    </div>
  );
};

export default ContactUs;
